(function () {
  'use strict';

  function enhanceFooter() {
    var footer = document.querySelector('.site-footer');
    if (!footer) return;
    var blocks = footer.querySelectorAll('.wrapper > .grid:first-child > .grid-item');
    Array.prototype.forEach.call(blocks, function (block, index) {
      var heading = block.querySelector('h3');
      if (!heading || block.querySelector('.er-footer-toggle')) return;

      heading.classList.add('er-footer-heading');
      var button = document.createElement('button');
      button.type = 'button';
      button.className = 'er-footer-toggle';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', 'er-footer-panel-' + index);
      button.textContent = heading.textContent;

      var panel = document.createElement('div');
      panel.className = 'er-footer-collapsible';
      panel.id = 'er-footer-panel-' + index;
      while (heading.nextSibling) panel.appendChild(heading.nextSibling);
      heading.parentNode.insertBefore(button, heading.nextSibling);
      button.parentNode.insertBefore(panel, button.nextSibling);

      button.addEventListener('click', function () {
        var open = button.getAttribute('aria-expanded') === 'true';
        button.setAttribute('aria-expanded', open ? 'false' : 'true');
        panel.classList.toggle('is-open', !open);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceFooter);
  } else {
    enhanceFooter();
  }
})();
